module.exports = __webpack_public_path__ + "img/exante_cura_nucleo_no_massimale.60f2aed0.jpg";